import { useSelector } from 'react-redux';
import { SummariesData } from '../../redux/localReports/localReports.proptype';
import { selectSummariesData } from '../../selectors';

export const useSummariesData = (): SummariesData => {
  const summariesData = useSelector(selectSummariesData);

  return summariesData;
};
